import { Box, Grid2 as Grid } from '@mui/material';
import { color } from '@/colors';
import { NodeViewMode } from '@/enums/node-view-mode.enum';
import { NodeProperties } from './NodeProperties';
import { RunModelsSection } from './RunModelsSection';
import type { Node } from '@/types/node';

const NODES_WITH_PROPERTIES_DISPLAYED = ['wildcardV2', 'custommodelV2', 'masks', 'number_selector'];

export function shouldShowWorkflowPropertiesForNode(n: Node): boolean {
  if (!n.type) return false;
  return (
    NODES_WITH_PROPERTIES_DISPLAYED.includes(n.type) ||
    (n.type === 'muxv2' && !(n.data as { isIterator?: boolean }).isIterator) ||
    (n.type === 'multilora' && (n.data as { viewMode?: NodeViewMode }).viewMode !== NodeViewMode.Single)
  );
}

export function hasDisplayableWorkflowProperties(selectedNodes: Node[]): boolean {
  return selectedNodes.some(shouldShowWorkflowPropertiesForNode);
}

function shouldShowRunModelsSection(nodes: Node[]): boolean {
  return nodes.some((node) => node.isModel && node.type !== 'masks');
}

interface WorkflowPropertiesPanelProps {
  selectedNodes: Node[];
}

export function WorkflowPropertiesPanel({ selectedNodes }: WorkflowPropertiesPanelProps) {
  const nodesWithProperties = selectedNodes.filter(shouldShowWorkflowPropertiesForNode);

  if (nodesWithProperties.length === 0) return null;

  return (
    <>
      <Grid size="grow" sx={{ overflowY: 'auto' }} className="wea-no-scrollbar">
        <Box sx={{ p: nodesWithProperties.length > 1 ? 0 : 2 }}>
          {nodesWithProperties.map((node) => (
            <NodeProperties key={node.id} node={node} selectedNodes={nodesWithProperties} />
          ))}
        </Box>
      </Grid>

      {shouldShowRunModelsSection(selectedNodes) ? (
        <Grid
          size="auto"
          sx={{
            width: '100%',
            borderTop: `1px solid ${color.White40_T}`,
          }}
        >
          <RunModelsSection selectedNodes={selectedNodes} />
        </Grid>
      ) : null}
    </>
  );
}
